/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Environment } from '../models/Environment';
import { ScalarOperators } from '../models/ScalarOperators';

export class EnvironmentCondition {
  'operator': ScalarOperators;
  'environments': Array<Environment>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "operator",
      "baseName": "operator",
      "type": "ScalarOperators",
      "format": ""
    },
    {
      "name": "environments",
      "baseName": "environments",
      "type": "Array<Environment>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EnvironmentCondition.attributeTypeMap;
  }

  public constructor() {
  }
}



